import apiFetch from "./apiClient";
import { cachearConfigNovedades } from "../data/novedadesConfig";

/**
 * Lado servidor de la configuración de Novedades. Vive aparte de
 * `data/novedadesConfig.js` para no cerrar el ciclo de imports
 * changelog → apiClient → sesion → changelog (ver la nota en ese archivo).
 */

/** Trae la configuración y la deja cacheada. Nunca lanza: si falla, el modal
 *  simplemente no se abre hasta el próximo intento. */
export async function cargarConfigNovedades() {
  try {
    const res = await apiFetch("/api/core/novedades/config/");
    if (!res.ok) return null;
    const data = await res.json();
    cachearConfigNovedades(data);
    return data;
  } catch {
    return null;
  }
}

/** Guarda la configuración (solo superadministrador). */
export async function guardarConfigNovedades(data) {
  const res = await apiFetch("/api/core/novedades/config/", {
    method: "PATCH",
    body: JSON.stringify(data),
  });
  const d = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(d.detail || Object.values(d).flat().join(". ") || "No se pudo guardar.");
  }
  cachearConfigNovedades(d);
  return d;
}
